/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { CreateProductUpdateJobsFromStagingRequestDTOToJSON, DeleteFromProductStagingRequestDTOToJSON, MoveToProductStagingRequestDTOToJSON, PaginatedResponseProductStagingDTOFromJSON, ProductStagingRequestDTOToJSON, } from '../models/index';
/**
 *
 */
export class ProductStagingControllerApi extends runtime.BaseAPI {
    /**
     */
    async createProductUpdateJobsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling createProductUpdateJobs().');
        }
        if (requestParameters['createProductUpdateJobsFromStagingRequestDTO'] == null) {
            throw new runtime.RequiredError('createProductUpdateJobsFromStagingRequestDTO', 'Required parameter "createProductUpdateJobsFromStagingRequestDTO" was null or undefined when calling createProductUpdateJobs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-staging/{marketplace}/createProductUpdateJobs`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProductUpdateJobsFromStagingRequestDTOToJSON(requestParameters['createProductUpdateJobsFromStagingRequestDTO']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async createProductUpdateJobs(requestParameters, initOverrides) {
        const response = await this.createProductUpdateJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteFromStagingRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling deleteFromStaging().');
        }
        if (requestParameters['deleteFromProductStagingRequestDTO'] == null) {
            throw new runtime.RequiredError('deleteFromProductStagingRequestDTO', 'Required parameter "deleteFromProductStagingRequestDTO" was null or undefined when calling deleteFromStaging().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-staging/{marketplace}/deleteFromStaging`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteFromProductStagingRequestDTOToJSON(requestParameters['deleteFromProductStagingRequestDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteFromStaging(requestParameters, initOverrides) {
        await this.deleteFromStagingRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getStagedProductsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getStagedProducts().');
        }
        if (requestParameters['productStagingRequestDTO'] == null) {
            throw new runtime.RequiredError('productStagingRequestDTO', 'Required parameter "productStagingRequestDTO" was null or undefined when calling getStagedProducts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-staging/{marketplace}/staged-products`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductStagingRequestDTOToJSON(requestParameters['productStagingRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseProductStagingDTOFromJSON(jsonValue));
    }
    /**
     */
    async getStagedProducts(requestParameters, initOverrides) {
        const response = await this.getStagedProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async moveToStagingRaw(requestParameters, initOverrides) {
        if (requestParameters['moveToProductStagingRequestDTO'] == null) {
            throw new runtime.RequiredError('moveToProductStagingRequestDTO', 'Required parameter "moveToProductStagingRequestDTO" was null or undefined when calling moveToStaging().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/product-staging/moveToStaging`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MoveToProductStagingRequestDTOToJSON(requestParameters['moveToProductStagingRequestDTO']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async moveToStaging(requestParameters, initOverrides) {
        const response = await this.moveToStagingRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const CreateProductUpdateJobsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const DeleteFromStagingMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const GetStagedProductsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
